import $ from "jquery";
import { Menu, MenuWrapper } from "../interfaces/menu.interface";
import { MenuImpl, MenuWrapperImpl } from "../models/menu.model";
import { InCoreSwal2, InCoreSwal2Icon } from "../utils/swal.utils";

export async function menuAdd(btn: HTMLElement): Promise<void> {
    const level = $(btn).data("level");
    let clone: JQuery<HTMLElement>;

    if (level === "0") {
        clone = $(".card.copyMe").clone();
    } else {
        clone = $(".row.copyMe").clone();
    }

    clone.find(".m").each((_, element) => {
        const item = $(element);
        if (level === "0") {
            item.addClass("menu");
        } else if (level === "1") {
            item.addClass("submenu");
        } else {
            item.addClass("subsubmenu");
        }
        item.removeClass("m");
    });

    clone.find(".removeButtonMenu").first().remove();
    clone.removeClass("copyMe").find(".copyMe").removeClass("copyMe");

    if (level === "0") {
        clone.prependTo(".col-md-12.blockMenu");
    } else {
        const div = $("<div />")
            .css("margin-top", "5px")
            .addClass("menuSettings")
            .addClass(level === "1" ? "submenu" : "subsubmenu")
            .addClass("row");

        clone.appendTo(div);
        div.appendTo($(btn).parent().parent());
    }
}

export async function menuRemove(): Promise<void> {
    InCoreSwal2(InCoreSwal2Icon.Question, "Confermi la cancellazione di questo elemento?<br/>ATTENZIONE: eliminare una voce 'padre' rimuover&agrave; tutti le voci 'figlie'!")
        .then((result) => {
            if (result.isConfirmed) {
                const button = $(result.target); // Explicitly reference the target element
                const level = button.data("level");
                if (level === "0") {
                    button.closest(".menu").remove();
                } else {
                    button.closest(".submenu, .subsubmenu").remove();
                }
            }
        });
}

export function menuSave(evt: JQuery.SubmitEvent): void {
    evt.preventDefault();

    const menus: Menu[] = [];
    $(".menu.row").each((_, element) => {
        const row = $(element);
        const submenus: Menu[] = [];

        row.find(".submenu.row").each((_, subElement) => {
            const subRow = $(subElement);
            const subsubmenus: Menu[] = [];

            subRow.find(".subsubmenu.row").each((_, subsubElement) => {
                const subsubRow = $(subsubElement);
                const subsubmenu = new MenuImpl(
                    subsubRow.find(".subsubmenu.mname").val() as string,
                    subsubRow.find(".subsubmenu.mhref").val() as string,
                    subsubRow.find(".subsubmenu.mclasses").val() as string,
                    subsubRow.find(".subsubmenu.micon").val() as string,
                    subsubRow.find(".subsubmenu.mbadge").val() as string,
                    subsubRow.find(".subsubmenu.mbadgetext").val() as string,
                    subsubRow.find(".subsubmenu.mclaim").val() as string,
                    subsubRow.find(".subsubmenu.morder").val() as string,
                    subsubRow.find(".subsubmenu.mispublic").prop("checked"),
                    []
                );
                subsubmenus.push(subsubmenu);
            });

            const submenu = new MenuImpl(
                subRow.find(".submenu.mname").val() as string,
                subRow.find(".submenu.mhref").val() as string,
                subRow.find(".submenu.mclasses").val() as string,
                subRow.find(".submenu.micon").val() as string,
                subRow.find(".submenu.mbadge").val() as string,
                subRow.find(".submenu.mbadgetext").val() as string,
                subRow.find(".submenu.mclaim").val() as string,
                subRow.find(".submenu.morder").val() as string,
                subRow.find(".submenu.mispublic").prop("checked"),
                subsubmenus
            );
            submenus.push(submenu);
        });

        const menu = new MenuImpl(
            row.find(".menu.mname").val() as string,
            row.find(".menu.mhref").val() as string,
            row.find(".menu.mclasses").val() as string,
            row.find(".menu.micon").val() as string,
            row.find(".menu.mbadge").val() as string,
            row.find(".menu.mbadgetext").val() as string,
            row.find(".menu.mclaim").val() as string,
            row.find(".menu.morder").val() as string,
            row.find(".menu.mispublic").prop("checked"),
            submenus
        );
        menus.push(menu);
    });

    const menuWrapper = new MenuWrapperImpl(menus);

    $.ajax({
        type: "POST",
        url: "/Admin/Menu",
        data: menuWrapper,
        success: () => {
            InCoreSwal2(InCoreSwal2Icon.Success, "Menu salvati!").then(() => location.reload());
        },
        error: (result) => {
            InCoreSwal2(InCoreSwal2Icon.Error, result.responseText);
        }
    });
}